import { clientClient } from 'servicesCommon/client';
import { AxiosTypedPromise } from 'servicesCommon/apiTypes';
import { CountriesResponse, CarTypesResponse, CitiesResponse } from './BokkingDictionariesTypes';

const formatUrl = (url: string) => `/bookings-dictionaries/${url}`;

export const bookingDictApi = {
	retrieveCountries: (): AxiosTypedPromise<CountriesResponse> => {
		return clientClient.get(formatUrl('get-countries'));
	},
	retrieveCities: (countryId: number | string): AxiosTypedPromise<CitiesResponse> => {
		return clientClient.get(formatUrl('get-cities'), {
			params: {
				countryId,
			},
		});
	},
	retrieveCarTypes: (): AxiosTypedPromise<CarTypesResponse> => {
		return clientClient.get(formatUrl('get-car-types'));
	},
};
